import { motion } from 'framer-motion';
import type { PublicPlayer } from 'shared';
import { Avatar } from '../design/Avatar';
import { Panel } from '../design/Panel';
import { Stamp } from '../design/Stamp';
import { tiltFor } from '../design/tokens';
import { ro } from '../i18n/ro';

/**
 * The roster has to hold five to fifteen people without overflowing a fixed
 * 16:9 frame, so the column count comes from the headcount and every entry
 * stays on one line.
 */
export function Roster({ players }: { players: PublicPlayer[] }) {
  const columns = players.length > 8 ? 3 : 2;

  return (
    <div
      className="grid w-full content-center gap-[1cqw]"
      style={{ gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))` }}
    >
      {players.map((p) => (
        <motion.div
          key={p.id}
          layout
          initial={{ opacity: 0, y: -18, scale: 0.94 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          transition={{ type: 'spring', stiffness: 420, damping: 26 }}
        >
        <Panel
          press="sm"
          className={tiltFor(p.id)}
          innerClassName="flex min-w-0 items-center gap-[1cqw] px-[1cqw] py-scr-1"
        >
          <Avatar
            subject={p}
            size="sm"
            dimmed={!p.alive}
            className="h-[7cqh] w-[7cqh] min-h-5 min-w-5 text-[2.2cqh]"
          />
          <span className="min-w-0 flex-1 truncate font-display text-screen-sm uppercase">
            {p.name}
          </span>
          {!p.alive && (
            <Stamp tone="red" size="sm" className="shrink-0">
              {ro.executed}
            </Stamp>
          )}
        </Panel>
        </motion.div>
      ))}
    </div>
  );
}
